import SeeDentistOptionsForm from "../../components/SeeDentist/SeeDentistOptionsForm";
import SeeDentistTabs from "../../components/SeeDentist/SeeDentistTabs";

const SeeDentistOptions = () => {
  return (
    <>
      <body>
        <section className="step-section py-4 py-md-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="bg-white border-radius-xlg px-4 px-md-5 py-4">
                  <SeeDentistTabs />
                  <SeeDentistOptionsForm />
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
    </>
  );
};

export default SeeDentistOptions;
